import React from 'react';
import { Container, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function FAQs() {
  return (
    <Container maxWidth="md" style={{ marginTop: '3rem', marginBottom: '3rem' }}>
      <Typography variant="h4" align="center" gutterBottom style={{ fontWeight: 'bold', marginBottom: '1.5rem' }}>
        Frequently Asked Questions
      </Typography>
      
      {/* First Accordion */}
      <Accordion style={{ marginBottom: '1rem', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ padding: '0 1rem' }}>
          <Typography variant="subtitle1" style={{ fontWeight: '600' }}>
            What accounting services do you provide?
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ padding: '1rem' }}>
          <Typography variant="body1">
            We offer a full range of accounting services including bookkeeping, payroll management, financial reporting, auditing, and financial statement preparation. Our services are designed to keep your business's finances organized and compliant.
          </Typography>
        </AccordionDetails>
      </Accordion>

      {/* Second Accordion */}
      <Accordion style={{ marginBottom: '1rem', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ padding: '0 1rem' }}>
          <Typography variant="subtitle1" style={{ fontWeight: '600' }}>
            Do you handle both business and individual taxes?
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ padding: '1rem' }}>
          <Typography variant="body1">
            Yes, we handle tax preparation and filing for both businesses and individuals. Our services cover income tax, corporate tax, VAT, and more, ensuring you remain compliant and minimize your tax liabilities.
          </Typography>
        </AccordionDetails>
      </Accordion>

      {/* Third Accordion */}
      <Accordion style={{ marginBottom: '1rem', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ padding: '0 1rem' }}>
          <Typography variant="subtitle1" style={{ fontWeight: '600' }}>
            How do you help businesses with tax planning?
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ padding: '1rem' }}>
          <Typography variant="body1">
            We provide proactive tax planning strategies to help businesses reduce their tax burden. Our team identifies opportunities for deductions, credits, and other savings, ensuring you make the most of your financial situation while staying compliant with tax laws.
          </Typography>
        </AccordionDetails>
      </Accordion>

      {/* Fourth Accordion */}
      <Accordion style={{ marginBottom: '1rem', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ padding: '0 1rem' }}>
          <Typography variant="subtitle1" style={{ fontWeight: '600' }}>
            What industries do you serve?
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ padding: '1rem' }}>
          <Typography variant="body1">
            We serve a variety of industries including SMEs, manufacturing, real estate, healthcare, retail, hospitality, and professional services. Our team understands the unique financial needs and regulations in each industry, providing tailored accounting solutions.
          </Typography>
        </AccordionDetails>
      </Accordion>

      {/* Fifth Accordion */}
      <Accordion style={{ marginBottom: '1rem', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ padding: '0 1rem' }}>
          <Typography variant="subtitle1" style={{ fontWeight: '600' }}>
            How do you ensure compliance with tax regulations?
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ padding: '1rem' }}>
          <Typography variant="body1">
            We stay up to date with the latest tax laws and regulations to ensure that your business remains compliant. Our team continuously monitors changes in tax policies and applies best practices to keep your financial operations aligned with current legal requirements.
          </Typography>
        </AccordionDetails>
      </Accordion>

    </Container>
  );
}

export default FAQs;
